import convertList from '../../convertList';

function getList(type, params) {
    return new Promise((resolve, reject) => {
        const data = {
            success(res) {
                resolve(res);
            },
            fail(res) {
                reject(res);
            },
            ...params
        };
        try {
            qdp[`get${type}List`](data);
        } catch (error) {
            throw new Error(`调用jsBrige方法失败, 方法名: get${type}List`);
        }
    });
}

export default function(data) {
    const { type, maps, moreConfig, cancelConvertList, params } = data;
    return new Promise((resolve, reject) => {
        getList(type, params).then(
            res => {
                if (res.data.list && res.data.list.length) {
                    if (cancelConvertList) {
                        resolve(res.data.list);
                    } else {
                        const newList = convertList(res.data.list, maps, moreConfig);
                        resolve(newList);
                    }
                } else {
                    resolve([]);
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
